import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import CircularProgress from "@material-ui/core/CircularProgress";

import fb from "./ConfiguredFirebase";

const useStyles = makeStyles({
  title: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  subtitle: {
    paddingBottom: "10px",
  },
  legend: {
    paddingBottom: "10px",
  },
  progress: {
    marginTop: "20px",
    marginLeft: "40px",
    marginRight: "40px",
    paddingTop: "10px",
  },
  emailContainer: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  emailHeader: {
    marginBottom: "20px",
  },
  questionField: {
    width: "400px",
  },
});

function QuickCheck({ questions, category }) {
  const classes = useStyles();
  let nullAnswers = [];
  questions.forEach((question) => {
    nullAnswers.push(question.choices.map((choice) => false));
  });
  const [sent, setSent] = useState(false);
  const [questionNumber, setQuestionNumber] = useState(0);
  const [answers, setAnswers] = useState(nullAnswers);
  const [company, setCompany] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState({ exists: false, message: "" });
  const [messageOnFinish, setMessageOnFinish] = useState("");

  function ValidateEmail(text) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text)) {
      setEmailError({ exists: false, message: "" });
      setEmail(text);
    } else {
      setEmailError({ exists: true, message: "Ungültige E-Mail-Adresse!" });
    }
  }

  const HandleCheckbox = (event) => {
    let idx = parseInt(event.target.name);
    let newChoices;
    if (questions[questionNumber].singleAnswer) {
      newChoices = new Array(answers[questionNumber].length).fill(false);
      newChoices[idx] = event.target.checked;
    } else {
      newChoices = [
        ...answers[questionNumber].slice(0, idx),
        event.target.checked,
        ...answers[questionNumber].slice(idx + 1),
      ];
    }

    let newAnswers = [
      ...answers.slice(0, questionNumber),
      newChoices,
      ...answers.slice(questionNumber + 1),
    ];
    setAnswers(newAnswers);
  };

  const Submit = () => {
    setSent(true);
    answers.forEach((a, idx) => {
      questions[idx].answers = a;
    });
    fb.firestore
      .collection("Antworten")
      .add({
        category,
        questions,
        email,
        userName,
        company,
        createdAt: new Date().toISOString(),
      })
      .then(() => {
        setMessageOnFinish("Erfolgreich abgesendet, vielen Dank!");
      })
      .catch((error) => {
        setMessageOnFinish(`Fehler: ${error}`);
      });
  };

  const HandleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (!emailError.exists && email !== "") {
        Submit();
      }
    }
  };

  if (messageOnFinish !== "") {
    return (
      <Container maxWidth="md" className={classes.emailContainer}>
        <Typography color="textPrimary" className={classes.emailHeader}>
          {messageOnFinish}
        </Typography>
      </Container>
    );
  }
  return (
    <Grid
      container
      direction="column"
      className={classes.grid}
      justify="center"
    >
      {questionNumber === questions.length ? (
        <Container maxWidth="md" className={classes.emailContainer}>
          <Grid container direction="column" justify="left">
            <Typography color="textPrimary" className={classes.emailHeader}>
              Bitte geben Sie Ihre E-Mail-Adresse ein um Ihr Ergebnis zu
              erhalten.
            </Typography>
            <Typography color="textPrimary" className={classes.emailHeader}>
              > Mit der Angabe der Mailadresse in der Umfrage erklären Sie sich
              einverstanden, dass wir Ihre Daten speichern und Sie über die
              Mailadresse kontaktieren dürfen.{" "}
              <Link
                onClick={() =>
                  window.open(
                    "https://www.advacon.eu/datenschutzerkl%C3%A4rung",
                    "_blank"
                  )
                }
                color="secondary"
              >
                Unsere Datenschutzerklärung
              </Link>
            </Typography>
            <TextField
              className={classes.questionField}
              label="Name"
              defaultValue=""
              value={userName}
              onKeyPress={(event) => HandleKeyPress(event)}
              onChange={(event) => setUserName(event.target.value)}
            />
            <TextField
              className={classes.questionField}
              label="Firma"
              defaultValue=""
              value={company}
              onKeyPress={(event) => HandleKeyPress(event)}
              onChange={(event) => setCompany(event.target.value)}
            />
            <TextField
              className={classes.questionField}
              error={emailError.exists}
              label="E-Mail"
              defaultValue=""
              onKeyPress={(event) => HandleKeyPress(event)}
              helperText={emailError.message}
              onChange={(event) => ValidateEmail(event.target.value)}
            />
          </Grid>
        </Container>
      ) : (
        // Hier sind die Ueberschriften!
        <Container maxWidth="md">
          <Typography
            variant="h6"
            color="textPrimary"
            className={classes.title}
          >
            {questions[questionNumber].category}
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.subtitle}
          >
            {questions[questionNumber].subtitle}
          </Typography>
          <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.legend}>
              {questions[questionNumber].description}
            </FormLabel>
            <FormGroup>
              {questions[questionNumber].choices.map((choice, index) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={answers[questionNumber][index]}
                      onChange={HandleCheckbox}
                      style={{ cursor: "pointer" }}
                    />
                  }
                  label={choice}
                  name={index.toString()}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Container>
      )}
      <Container maxWidth="md">
        <Grid container xs={12} direction="row">
          <Grid item xs={4}>
            {questionNumber !== 0 && (
              <Button
                disabled={sent}
                variant="contained"
                onClick={() => setQuestionNumber((oldNum) => oldNum - 1)}
                style={{ cursor: "pointer" }}
              >
                Zurück
              </Button>
            )}
          </Grid>
          <Grid item xs={4}>
            {questionNumber === questions.length ? (
              sent ? (
                <CircularProgress color="secondary" />
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={emailError.exists || email === ""}
                  onClick={() => {
                    Submit();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Abschicken!
                </Button>
              )
            ) : (
              <Button
                disabled={answers[questionNumber].every((el) => el === false)}
                variant="contained"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => setQuestionNumber((oldNum) => oldNum + 1)}
              >
                Weiter
              </Button>
            )}
          </Grid>
        </Grid>
      </Container>
      <Grid item>
        <LinearProgress
          variant="determinate"
          value={(questionNumber / questions.length) * 100}
          className={classes.progress}
        />
      </Grid>
    </Grid>
  );
}

export default QuickCheck;
